import type { ReactNode } from 'react';

export type StickerArtProps = { className?: string };

/**
 * A die-cut sticker: a white rim around one filled disc, bold shapes on top
 * (kid memory design §3.2). Drawn to read at 48 px on the celebration line as
 * well as at 160 px on a page, so no detail thinner than a 2-unit stroke.
 * Fixed colours, as the picture presets are: a page should look the same
 * wherever it is shown. The rim's faint outline keeps the sticker's edge
 * against the kid theme's pale background. Decorative; the caller names it.
 */
export function StickerFrame({
  background,
  className,
  children,
}: StickerArtProps & { background: string; children: ReactNode }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true" focusable="false">
      <circle cx="32" cy="32" r="31" fill="#ffffff" stroke="#1f2937" strokeOpacity="0.2" strokeWidth="1" />
      <circle cx="32" cy="32" r="27.5" fill={background} />
      {children}
    </svg>
  );
}
